import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Link, Slide, Skeleton } from "@mui/material";
import axios from "axios";
import { Close } from "@mui/icons-material";
import MemberService from "../../services/MemberService";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function OrgPrivacyPolicyLink({ children, underline }) {
    const privacyPolicyContent = useRef("");
    const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
    const [hasContent, setHasContent] = useState(false);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        // First, try to get Privacy Policy content
        MemberService.getPrivacyPolicy(source.token)
            .then(content => {
                if (content && content.trim() !== "") {
                    // Has content - use modal behavior
                    privacyPolicyContent.current = content;
                    setHasContent(true);
                } else {
                    // No content - fall back to link behavior
                    setHasContent(false);
                    return MemberService.getPrivacyPolicyLink(source.token);
                }
            })
            .then(url => {
                if (!hasContent && url) {
                    setPrivacyPolicyUrl(url);
                }
            })
            .catch(contentError => {
                if (!axios.isCancel(contentError)) {
                    // Privacy Policy content not found, try Privacy Policy Link
                    setHasContent(false);
                    return MemberService.getPrivacyPolicyLink(source.token)
                        .then(url => {
                            if (url && url.trim() !== "") {
                                setPrivacyPolicyUrl(url);
                            } else {
                                setPrivacyPolicyUrl("");
                            }
                        })
                        .catch(linkError => {
                            if (!axios.isCancel(linkError)) {
                                console.error("Neither privacy policy content nor link available:", linkError);
                                // Neither content nor link available
                                setPrivacyPolicyUrl("");
                            }
                        });
                }
            });
            
        return function cleanup() {
            source.cancel();
        };
    }, [hasContent]);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        if (open && hasContent) {
            setIsLoading(true);
            // Fetch privacy policy content for modal display
            MemberService.getPrivacyPolicy(source.token)
                .then(content => {
                    privacyPolicyContent.current = content;
                    setIsLoading(false);
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.error("Error loading privacy policy content:", error);
                        privacyPolicyContent.current = "Failed to load Privacy Policy. Please try again later.";
                        setIsLoading(false);
                    }
                });

            return function cleanup() {
                source.cancel();
            }
        }
    }, [open, hasContent]);

    if (hasContent) {
        // Modal behavior like TermsOfServiceLink
        return (
            <React.Fragment>
                <Link underline={underline || "always"} onClick={handleOpen}>
                    {children || "Privacy Policy"}
                </Link>
                <Dialog 
                    open={open}
                    scroll="paper"
                    onClose={handleClose}
                    TransitionComponent={Transition}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        Privacy Policy
                        <IconButton
                            size="large"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>                    
                        {isLoading ? (
                            <>
                                <Skeleton variant="rectangular" width="50%" style={{ marginBottom: 6 }}/>
                                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: 6 }}/>
                                <Skeleton variant="rectangular" width="75%" style={{ marginBottom: 6 }}/>
                            </>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent.current }} />
                        )}
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    } else {
        // Link behavior (current behavior)
        return (
            <Link 
                underline={underline || "always"}
                target="_blank"
                rel="noreferrer"
                href={privacyPolicyUrl || "#"}
            >
                {children || "Privacy Policy"}
            </Link>
        );
    }
}

export default OrgPrivacyPolicyLink;
